import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import MobileNav from './MobileNav';
import { MobileNavButtonDescriptor, TopBarContext } from 'common/layouts/AuthLayout/TopBarContext';

const MobileAppLayout = () => {
  const [topBarContent, setTopBarContent] = useState<React.ReactNode | null>(null);
  const [navButton, setNavButton] = useState<React.ReactNode | MobileNavButtonDescriptor | null>(null);

  return (
    <TopBarContext.Provider
      value={{
        setTopBarContent,
        setNavButton,
        openCopilot: () => {},
        topBarContent,
        navButton,
      }}
    >
      <Page>
        <MobileNav topBarContent={topBarContent} navButton={navButton} />
        <MainContent>
          <Outlet />
        </MainContent>
      </Page>
    </TopBarContext.Provider>
  );
};

export default MobileAppLayout;

const Page = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #ffffff;
`;

const MainContent = styled.div`
  padding: 20px 16px 40px;
  background: #ffffff;
`;
